export const HEADER_BLOCK_S08 = {
  "blockType": "HEADER",
  "blockDesign": "header_01",
  "styleProps": {
    "background-image": "url('https://d11lx8wl9i3fvs.cloudfront.net/1723883803066/1745685734111.png')",
    "background-color": "#c2c2c2",
    "padding": "120px 20px 120px 20px",
    "background-size": "cover",
    "background-repeat": "no-repeat",
    "background-position": "center"
  },
  "position": "left",
  "headingsStyleProps": {
    "padding": "10px 0px 10px 0px",
    "text-align": "center"
  },
  "headingsStylePropsTab": {
    "padding": "10px 0px 10px 0px"
  },
  "headingsStylePropsMob": {
    "padding": "10px 0px 10px 0px"
  },
  "headings": [
    {
      "styleProps": {
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "padding": "20px 0px 0px 0px",
        "font-weight": "500",
        "color": "#333333",
        "font-family-cust": "",
        "font-family": "'Lato', sans-serif",
        "margin": "0px 0px 0px 0px",
        "text-align": "left",
        "font-family-bk": "'Lato', sans-serif"
      },
      "stylePropsTab": {
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "padding": "20px 0px 20px 0px"
      },
      "stylePropsMob": {
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "padding": "20px 0px 20px 0px"
      },
      "text": "✸ 4.97/5 from over 400 reviews"
    },
    {
      "text": "Transforming Businesses with Innovative Software Solutions",
      "styleProps": {
        "font-size": "3.75rem",
        "line-height": "1",
        "color": "#333333",
        "margin": "0px 0px 0px 0px",
        "text-align": "left",
        "padding": "20px 0px 40px 0px",
        "font-family": "'Lato', sans-serif",
        "font-weight": "600"
      },
      "stylePropsMob": {
        "padding": "0px 0px 0px 0px",
        "font-size": "2.25rem",
        "line-height": "2.5rem"
      },
      "stylePropsTab": {
        "font-size": "3rem",
        "line-height": "1"
      }
    },
    {
      "text": "Discover our expertise in custom software development, mobile app development, cloud solutions, artificial intelligence & machine learning, cybersecurity, and IT consulting.",
      "styleProps": {
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "color": "#333333",
        "margin": "0px 0px 0px 0px",
        "text-align": "right",
        "padding": "20px 0px 40px 180px",
        "font-family": "'Lato', sans-serif",
        "font-weight": "400"
      },
      "stylePropsTab": {
        "padding": "20px 0px 30px 60px"
      },
      "stylePropsMob": {
        "padding": "20px 0px 20px 20px"
      }
    }
  ],
  "dynamicText": {
    "styleProps": {
      "font-size": "1.875rem",
      "line-height": "2.25rem",
      "padding": "10px 0px 10px 0px",
      "text-align": "center"
    },
    "stylePropsTab": {
      "padding": "10px 0px 10px 0px"
    },
    "stylePropsMob": {
      "padding": "10px 0px 10px 0px"
    },
    "strings": []
  },
  "descriptionsStyleProps": {
    "padding": "10px 0px 10px 0px",
    "text-align": "center"
  },
  "descriptionsStylePropsTab": {
    "padding": "10px 0px 10px 0px"
  },
  "descriptionsStylePropsMob": {
    "padding": "10px 0px 10px 0px"
  },
  "descriptions": [],
  "buttonsStyleProps": {},
  "buttons": [],
  "emailSecStyleProps": {},
  "subscription": {
    "showSection": "hide",
    "display": "enable",
    "subConfigs": {
      "configType": "convertkit",
      "configUrl": "https://app.convertkit.com/forms/xxxxxx/subscriptions",
      "configPlaceholder": ""
    },
    "email_placeholder": {
      "text": "example@mail.com"
    },
    "buttonText": {
      "text": "Subscribe",
      "styleProps": {
        "background-color": "#1b1b31",
        "color": "#ffffff"
      }
    },
    "successMessage": {
      "text": "Thank you for the signup",
      "styleProps": {}
    },
    "errorMessage": {
      "text": "Something went wrong. Please try again.",
      "styleProps": {}
    }
  },
  "textsStyleProps": {
    "text-align": "center"
  },
  "texts": [],
  "editFormName": "HEADER_FORM_01",
  "metaDataId": 1745685101652,
  "afterIndex": -1,
  "blockId": 1745685101652,
  "textBlock": {
    "descriptions": [
      {
        "text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        "styleProps": {
          "font-size": "1.125rem",
          "line-height": "1.75rem",
          "color": "#ffffff"
        }
      },
      {
        "text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        "styleProps": {
          "font-size": "1.125rem",
          "line-height": "1.75rem",
          "color": "#ffffff"
        }
      }
    ],
    "headings": [
      {},
      {},
      {}
    ]
  },
  "fonts": {
    "headings": [
      ""
    ]
  },
  "stylePropsMob": {
    "padding": "60px 20px 60px 20px"
  },
  "stylePropsTab": {
    "padding": "80px 20px 80px 20px"
  }
}